// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"1961a4d242dfa4ff6d02","263":"1921574fe5d915135a26","791":"8b9ac0563cc48b69f957"}[chunkId] + ".js";
};